import { createTheme } from "@mui/material/styles";

// Extend the existing Theme interface
declare module "@mui/material/styles" {
  interface Theme {
    color?: {
      primary?: string;
      primaryLight?: string;
      secondary?: string;
      primaryMedium?: string;
      background?: string;
      tableHeader?: string;
      secondaryLight?: string;
      success?: string;
      successLight?: string;
      warning?: string;
      warningLight?: string;
      dividerLight?: string;
      dividerMedium?: string;
      silver?: string;
      silverLight?: string;
      gold?: string;
      goldLight?: string;
      sideGrey?: string;
      greyBackground?: string;
      failure?: string;
      error?: string;
      errorLight?: string;
      active?: string;
      tableGrey?: string;
      dark?: string;
      readOnly?: string;
      diamond?: string;
      diamondLight?: string;
      sideMenuBackground?: string;
      sideMenuNewActive?: string;
      sideMenuNewInActive?: string;
      newFilterGrey?: string;
      newGreyBackground?: string;
      newGreyBackground2?: string;
      newGreyText?: string;
      searchBackground?: string;
      newTextColor?: string;
      cutOffGrey?: string;
    };
    height?: {
      xsmall?: string;
      small?: string;
      large?: string;
      xtlarge?: string;
    };
    border?: {
      xsmall?: string;
      medium?: string;
      smallGrey?: string;
      newGreyBorder?: string;
    };
    width?: {
      xsmall?: string;
      small?: string;
      large?: string;
      xtlarge?: string;
    };
    cursor?: {
      pointer?: string;
    };
    alignment?: {
      justifyContent?: {
        center?: string;
        left?: string;
        right?: string;
      };
      textAlign?: {
        center?: string;
        left?: string;
        right?: string;
      };
    };
    font?: {
      fontFamily: {
        primary?: string;
      };
      fontSize: {
        tableHeader?: string;
        tableBody?: string;
        cardHeader?: string;
        small?: string;
        medium?: string;
        large?: string;
      };
      fontWeight: {
        slightThick: string;
        thick?: string;
        thicker?: string;
      };
    };
  }

  // Extend the existing ThemeOptions interface
  interface ThemeOptions {
    color?: {
      primary?: string;
      primaryLight?: string;
      secondary?: string;
      background?: string;
      success?: string;
      successLight?: string;
      warning?: string;
      warningLight?: string;
      dividerLight?: string;
      silver?: string;
      silverLight?: string;
      gold?: string;
      goldLight?: string;
      sideGrey?: string;
      greyBackground?: string;
      failure?: string;
      error?: string;
      errorLight?: string;
      active?: string;
      tableGrey?: string;
      dark?: string;
      readOnly?: string;
      diamond?: string;
      diamondLight?: string;
      sideMenuBackground?: string;
      sideMenuNewActive?: string;
      sideMenuNewInActive?: string;
      newFilterGrey?: string;
      newGreyBackground?: string;
      newGreyBackground2?: string;
      newGreyText?: string;
      searchBackground?: string;
      newTextColor?: string;
      cutOffGrey?: string;
    };
    height?: {
      xsmall?: string;
      small?: string;
      large?: string;
      xtlarge?: string;
    };
    cursor?: {
      pointer?: string;
    };
    border?: {
      xsmall?: string;
      medium?: string;
      smallGrey?: string;
      newGreyBorder?: string;
    };
    width?: {
      xsmall?: string;
      small?: string;
      large?: string;
      xtlarge?: string;
    };
    alignment?: {
      justifyContent?: {
        center?: string;
        left?: string;
        right?: string;
      };
      textAlign?: {
        center?: string;
        left?: string;
        right?: string;
      };
    };
    font?: {
      fontFamily: {
        primary?: string;
      };
      fontSize: {
        tableHeader?: string;
        tableBody?: string;
        cardHeader?: string;
        small?: string;
        medium?: string;
        large?: string;
      };
      fontWeight: {
        slightThick: string;
        thick: string;
        thicker: string;
      };
    };
  }
}
// Create custom options for color
const color = {
  primary: "#1A3263",
  primaryLight: "#EAECF0",
  secondary: "#FFA500",
  background: "#FFFFFF",
  tableHeader: "#F6F6F6",
  secondaryLight: "#F7F0E2",
  primaryMedium: "#bfcff5",
  success: "#76CE16",
  successLight: "#ECFDF3",
  dividerLight: "#e7e7e7",
  dividerMedium: "#6B7280",
  greyBackground: "#f3f3f3",
  sideGrey: "#A3ADC1",
  silver: "#858C8C",
  silverLight: "#E9E9E9",
  gold: "#FFC42B",
  goldLight: "#FFE600",
  secondaryLightHover: "",
  failure: "#e60000",
  error: "#FF1010", //#F13950
  errorLight: "#FED9DE",
  active: "#FBFBFB38",
  tableGrey: "#667085",
  dark: "#000000",
  readOnly: "#f0f0f0",
  diamond: "#111113",
  diamondLight: "#6D6D6D",
  sideMenuBackground: "#F8F8F8",
  sideMenuNewActive: "#F1B53D",
  sideMenuNewInActive: "#AEAEAE",
  newFilterGrey: "#797B83",
  newGreyBackground: "#FAFAFA",
  newGreyBackground2: "#D8D8D8",
  newGreyText: "#949494",
  searchBackground: "#F9F9F9",
  newTextColor: "#252836",
  cutOffGrey: "#A2A2A2",
};

// create custom options for Border
const border = {
  xsmall: "1px solid",
  medium: "5px solid",
  smallGrey: "1px solid #EDEDED",
  newGreyBorder: "1px solid #D8D8D8",
};

// create custom options for Cursor
const cursor = {
  pointer: "pointer",
};

// create custom options for Height
const height = {
  xsmall: "0.2rem",
  small: "0.5rem",
  large: "1rem",
  xtlarge: "2rem",
};
// create custom options for width
const width = {
  xsmall: "0.2rem",
  small: "0.5rem",
  large: "1rem",
  xtlarge: "2rem",
};

// create custom options for alignment

const alignment = {
  justifyContent: {
    center: "center",
    left: "left",
    right: "right",
  },
  textAlign: {
    center: "center",
    left: "left",
    right: "right",
  },
};

const font = {
  fontFamily: {
    primary: "'Poppins', sans-serif",
  },
  fontSize: {
    tableHeader: "0.875rem",
    tableBody: "0.75rem",
    cardHeader: "0.875rem",
    small: "0.5rem",
    medium: "1rem",
    large: "1.5rem",
  },
  fontWeight: {
    slightThick: "400",
    thick: "500",
    thicker: "600",
  },
};

// Create a custom theme by merging the custom options with the existing theme
const theme = createTheme({
  color,
  height,
  width,
  alignment,
  border,
  cursor,
  font,
});

export default theme;
